import { useContext } from "react";
import { useIndex } from "@obby/components";
import { TableContext } from "./TableContext";

export function useVisibleColumn() {
  const index = useIndex();
  const { visibleColumns } = useContext(TableContext);
  return visibleColumns.includes(index);
}
